/** Créditos con el mismo ícono que el resto de la app (`token_icon.png`). Si no hay nada
 *  que generar (todo cacheado) dice "al día" en vez de un cero que parece un bug. */
export function IconoCreditos({ className = 'h-3.5 w-3.5' }: { className?: string }) {
  return <img src="/images/token_icon.png" alt="" aria-hidden className={`${className} inline-block object-contain`} />;
}

export function PillCreditos({ n, className = '', claro = false, siempre = false }: { n: number | null; className?: string; claro?: boolean; /** Mostrar también el 0 (y "…" mientras se calcula). */ siempre?: boolean; /** Compatibilidad: ya no se muestra nada con 0. */ regenerar?: number }) {
  if (!siempre && (n === null || n <= 0)) return null;
  const base = claro ? 'bg-white/20 text-white' : 'bg-[#E8EEFF] text-brand-primary';
  const texto = n === null ? '…' : String(n);
  const title = n === null ? 'Calculando…' : n === 0 ? 'No gasta créditos: todo está al día' : `${n} ${n === 1 ? 'crédito' : 'créditos'}`;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[11px] font-medium ${base} ${className}`} title={title}>
      <IconoCreditos /> {texto}
    </span>
  );
}
